import React from 'react';
import type TravelerInformation from '@this/src/domain/traveler_information';
import type OrderItem from '@this/src/domain/order_item2';
import type ChargingDepartmentShareMapping from '@this/src/domain/department/charging_department_share_mapping';
import type ProjectShareMapping from '@this/src/domain/project/project_share_mapping';
import ContentInfo from './content_info';

interface Props {
  item: OrderItem;
  traveler: TravelerInformation;
  total: number;
  type: string;
}

const ChargingShareContent: React.FC<Props> = ({ item, traveler, total, type }) => {
  const orderItemMapping = item.orderItemMappings.find(mapping => mapping.travelerInformationId === traveler.id);
  if (!orderItemMapping) {
    return null;
  }

  let shareList: ChargingDepartmentShareMapping[] | ProjectShareMapping[] = [];
  if (type === 'department') {
    const chargingDepartmentShare = orderItemMapping.chargingDepartmentShare;
    if (!chargingDepartmentShare || !orderItemMapping.chargingDepartmentShareId) {
      return null;
    }
    shareList = chargingDepartmentShare.chargingDepartmentShareMappings.list;
  }
  if (type === 'project') {
    const projectShare = orderItemMapping.projectShare;
    if (!projectShare || !orderItemMapping.projectShareId) {
      return null;
    }
    shareList = projectShare.projectShareMappings.list;
  }

  const price = item.price.price + (item.price.margin?.amount || 0);
  const amount = price / (total || 1);
  let sumWeight = 0;
  shareList.forEach(mapping => {
    sumWeight += mapping.weight;
  });

  let itemName = '';
  if (type === 'department') {
    itemName = orderItemMapping.chargingDepartment?.descriptionWithCode() || '';
  } else if (type === 'project') {
    itemName = orderItemMapping.project?.codeAndName() || '';
  }

  return (
    <>
      {shareList.map(mapping => {
        const proportionalPrice = amount * (mapping.weight / sumWeight);
        return (
          <ContentInfo
            key={mapping.id}
            item={item}
            traveler={traveler}
            price={Math.round(proportionalPrice)}
            itemName={itemName}
            index={mapping.id}
          />
        );
      })}
    </>
  );
};

export default ChargingShareContent;
